{
  "version": 1,
  "asset_id": "a60ac369-3eec-4636-b1dc-71e8e667f3eb",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a60ac369-3eec-4636-b1dc-71e8e667f3eb/dilated-pouch-boxed-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a60ac369-3eec-4636-b1dc-71e8e667f3eb/dilated-pouch-boxed-en-480.webp",
  "original_filename": "dilated-pouch-boxed-en-480.webp",
  "size": 17396,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:27:36Z"
}
